import React, { useState } from 'react'
import './Testimonial.css'
import {testimonialsData} from '../../data/testimonialsData'
import leftArrow from '../../assets/leftArrow.png'
import righttArrow from '../../assets/rightArrow.png'
import {motion}  from 'framer-motion'

export const Testimonial = () => {
    const transition = {type:"spring",duration:3}
    const [Selected,setSelected] = useState(0);
const Tlength = testimonialsData.length;
  return (
    <div className="testimonial" id='testimonial'>
        <div className="left-t">
        <span >Testimonials</span>
        <span className='stroke-text'>What They</span>
        <span>Say about us</span>
        <motion.span key={Selected}
            initial={{opacity:0,x:-100}}
            animate={{opacity:1,x:0}}
            exit={{opacity:0,x:100}}
            transition={transition}>{testimonialsData[Selected].review}</motion.span>
        <span>
            <span>{testimonialsData[Selected].name}{" "}</span>
            - {testimonialsData[Selected].status}
        </span>
        </div>
        <div className="right-t">
            <motion.div 
            initial={{opacity:0,x:-100}} 
            whileInView={{opacity:1,x:0}} 
            transition={{...transition,duration:2}}></motion.div>
            <motion.div 
            initial={{opacity:0,x:100}}
            whileInView={{opacity:1,x:0}}
            transition={{...transition,duration:2}}></motion.div>
            <motion.img 
            key={Selected}
            initial={{opacity:0,x:100}}
            animate={{opacity:1,x:0}}
            exit={{opacity:0,x:-100}}
            transition={transition}
            src={testimonialsData[Selected].image} alt="" />
            <div className="Arrows">
                <img src={leftArrow}  alt=""  
                onClick={()=>{
                    Selected === 0 ? setSelected(Tlength-1):setSelected((prev)=>prev-1)}
                }
                />
                <img src={righttArrow} alt="" onClick={()=>{
                    Selected === Tlength-1 ? setSelected(0):setSelected((prev)=>prev+1)}
                }/>
            </div>
        </div>
    </div>
  )
}
